import PostFilter from './post-filter';

export default PostFilter;